// extracted by mini-css-extract-plugin
export var gridHidden = "navigation-menu-mobile-hs-module--grid-hidden--a54bc";
export var navigationMenuMobile = "navigation-menu-mobile-hs-module--navigation-menu-mobile--3bb3f";